import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpService } from "services/http.service";
import { QueryParams } from "services/models/odata/queryParams";
import { ProbationaryPeriodEmployeeModel } from "services/models/probationary-period/probationary-period-employee.model";
import { ServiceBase } from "services/servicebase";
import { Response } from "services/models/response";
import { HTTP_CACHE_HEADERS } from "utils/http-cache.constants";

@Injectable()
export class ProbationaryPeriodEmployeeService extends ServiceBase<ProbationaryPeriodEmployeeModel> {
  constructor(http: HttpService) {
    super("probationaryperiod/employee", http, environment.apiUrl);
  }

  createEntity(input: any): ProbationaryPeriodEmployeeModel {
    return ProbationaryPeriodEmployeeModel.create(input);
  }

  getList(
    params: QueryParams,
    disableLoading = true,
    extraParams?: string
  ): Observable<Response<ProbationaryPeriodEmployeeModel[]>> {
    const defaultSelect = [];

    params.select = [
      ...params.select.filter((field) => !defaultSelect.includes(field)),
      ...defaultSelect,
    ];

    const query = this.createBuildQuery(params);
    const extraQuery = extraParams ? `${query.includes('?') ? '&' : '?'}${extraParams}` : '';

    return this.http
      .get(
        `${this.endpoint}/list${query}${extraQuery}`,
        HTTP_CACHE_HEADERS.NO_CACHE,
        this.baseUrl,
        null,
        disableLoading
      )
      .pipe(
        map((res) => {
          const response = new Response<ProbationaryPeriodEmployeeModel[]>();
          response.data = res.body.map(
            (pp) => this.createEntity(pp) as ProbationaryPeriodEmployeeModel
          );
          response.count = res.headers.get("x-count");
          return response;
        })
      );
  }

  getProbationaryEmployee(
    id: string
  ): Observable<ProbationaryPeriodEmployeeModel> {
    return this.http
      .get(`${this.endpoint}/${id}`, null, null, null, true)
      .pipe(
        map((data: any) => ProbationaryPeriodEmployeeModel.create(data.body))
      );
  }
}
